import { inject, Pipe, PipeTransform } from '@angular/core';
import { ComponentLoaderService } from '@services/component-loader';

@Pipe({
  name: 'getComponentByType',
  standalone: true,
})
export class GetComponentByTypePipe implements PipeTransform {
  readonly #componentLoaderService = inject(ComponentLoaderService);

  transform(value: string): unknown {
    return this.#componentLoaderService.getComponent(value) ?? null;
  }
}
